import { HttpClient } from "@/shared/HttpClient";

import { router } from "@/plugins/Router";
import { SecurityService } from "@/security/SecurityService";
import { SecurityStoreMethods } from "@/store/security/SecurityStore";
import { Mutation } from "vuex-class";

import store from '@/store';


/**
 * Helper pour la gestion des couleurs.
 */
export class AuthHelper {



    public static setConnexionSuccess(flag: boolean): void {
        store.commit(SecurityStoreMethods.SET_CONNEXION_SUCCESS, flag);
    }

    public static setConnexionInProgress(flag: boolean): void {
        store.commit(SecurityStoreMethods.SET_CONNEXION_EN_COURS, flag);
    }


    /**
     * Méthode custom de traitement de la partie redirection après connexion.
     * Elle est exécutée automatiquement à la fin de l'appel handleLoginRedirect() d'okta-vue.
     * La configuration du callback est faite dans mains.ts.
     * @param originalUri
     */
    public static async restoreOriginalUriCustom(
        originalUri: string | undefined
    ): Promise<void> {
        // Configuration du token d'accès à transmettre dans les requêtes axios.
        HttpClient.setAuthorizationHeaders();

        // Appel au back pour vérifier le besoin de création utilisateur.
        await SecurityService.init()
            .then((response) => {

                this.setConnexionSuccess(response);
                if (response) {
                    router.replace(originalUri!);
                } else {
                    router.replace("");
                }
            })
            .finally(() => {
                this.setConnexionInProgress(true);
            });
    }
}
